<template>
  <div class="note-folder-list-container">
    <div class="title-box primary-box">
      <h1>{{ getTranslation("note-main-folder-list")}}</h1>
    </div>
    <div class="card-deck">
      <v-card
          class="card"
          v-for="mainFolder in mainFolders" :key="mainFolder.id"
      >
        <router-link :to="`/notebook/${mainFolder.id}`">
          <v-img src="/img/notebooks.svg" :alt="mainFolder.name" height="150px"></v-img>
          <div class="card-description">
            <v-card-title itemprop="headline">{{ mainFolder.name }}</v-card-title>
          </div>
        </router-link>
      </v-card>
    </div>
  </div>
</template>
<script>
import {updateMetaInfo} from "@/middleware/metaUpdater";
import {getTranslation} from "@/services/stringTableService";
import apiService from "@/services/ApiService";

export default {
  methods: {
    getTranslation(key) {
      return getTranslation(this.language, key);
    },
    async fetchMainFolders() {
      try {
        this.$store.dispatch('setLoading', true);
        const mainFolders = await apiService.getMainFolders();
        this.mainFolders = mainFolders.sort((a, b) => {
          const nameA = a.name?.get(this.language).toUpperCase();
          const nameB = b.name?.get(this.language).toUpperCase();
          return nameA.localeCompare(nameB);
        });
      } catch (error) {
        console.error("Error fetching main folders:", error);
      } finally {
        this.$store.dispatch('setLoading', false);
      }
    },
  },
  data() {
    return {
      mainFolders: [],
      language: "IT"
    }
  },
  async mounted() {
    await this.fetchMainFolders();
    updateMetaInfo({
      title: "Notebooks - Cinopedia.cloud",
      description: "Notebooks - Cinopedia.cloud",
    });

    window.scrollTo(0, 0)
  }
}
</script>
<style scoped lang="scss">
@import "../style/_variables.scss";
.note-folder-list-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
</style>